import { render, staticRenderFns } from "./order_close_dialog.vue?vue&type=template&id=1ac80b24"
import script from "./order_close_dialog.vue?vue&type=script&lang=js"
export * from "./order_close_dialog.vue?vue&type=script&lang=js"
import style0 from "./order_close_dialog.vue?vue&type=style&index=0&id=1ac80b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports